// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Identity type to use in authentication.
 *
 * @beta
 */
export enum IdentityType {
  /**
   * Represents the current user of Teams.
   */
  User = "User",
  /**
   * Represents the application itself.
   */
  App = "Application",
}
